import { IsFlexActionTypes, SET_IS_FLEX } from './isFlexActionTypes';

export const setIsFlex = (isFlex: boolean): IsFlexActionTypes => ({
	type: SET_IS_FLEX,
	payload: isFlex,
});
